export const ACCOUNT_USER_CART_DETAIL_MODEL = {
  /**
   *  총 결제 금액
   */
  totalPrice: 0,
  /**
   *  상품 수량
   */
  quantity: 0,
  /**
   *  총 장바구니 추가 수
   */
  addToCartAmount: 0,
  /**
   *  총 장바구니 삭제 수
   */
  removeToCartAmount: 0,
};

/**
 *  유저 상세 > 장바구니 정보 > 장바구니 타임라인 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_CART_LOG_LIST_FILTER_OPTION_MODEL = {
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  브랜드명
   */
  storeName: null,
  /**
   *  상품 ID
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  활동 내역
   */
  actionLogType: null,
  /**
   *  활동시간
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  유저 상세 > 장바구니 정보 > 장바구니 타임라인 리스트 정렬 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_CART_LOG_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];
